import {
  emailValidator,
  nipValidator,
  phoneValidator,
  repeatEmailValidator,
  zipCodeValidator,
} from "../../../../utils/formsValidation";
import { FormElementModel } from "../../../models/FormElementModel";

export const userPayForm = (watch: any, register: any): FormElementModel[] => [
  {
    name: "firstName",
    type: "text",
    text: "Imię",
    isLabel: true,
    register: { ...register("firstName", { required: true }) },
  },
  {
    name: "lastName",
    type: "text",
    text: "Nazwisko",
    isLabel: true,
    register: { ...register("lastName", { required: true }) },
  },
  {
    name: "email",
    type: "text",
    text: "E-mail",
    isLabel: true,
    register: { ...register("email", { ...emailValidator(true) }) },
  },
  {
    name: "repeatEmail",
    type: "text",
    text: "Powtórz e-mail",
    isLabel: true,
    register: { ...register("repeatEmail", { ...repeatEmailValidator(true, watch("email", "")) }) },
  },
  {
    name: "phone",
    type: "number",
    text: "Numer telefonu",
    isLabel: true,
    register: { ...register("phone", { ...phoneValidator(true) }) },
  },
];

export const invoiceForm = (register: any, isCompanyInvoice: boolean): FormElementModel[] => [
  {
    name: "companyName",
    type: "text",
    text: "Nazwa firmy",
    isLabel: true,
    register: { ...register("companyName", { required: true }) },
  },
  isCompanyInvoice
    ? {
        name: "NIP",
        type: "text",
        text: "NIP",
        isLabel: true,
        register: { ...register("NIP", { ...nipValidator(true, true) }) },
      }
    : ({} as FormElementModel),
  {
    name: "street",
    type: "text",
    text: "Ulica",
    isLabel: true,
    register: { ...register("street", { required: true }) },
  },
  {
    name: "houseNumber",
    type: "text",
    text: "Numer domu",
    isLabel: true,
    register: { ...register("houseNumber", { required: true }) },
  },
  {
    name: "flatNumber",
    type: "text",
    text: "Numer mieszkania",
    isLabel: true,
    register: { ...register("flatNumber", { required: true }) },
  },
  {
    name: "zipCode",
    type: "text",
    text: "Kod pocztowy",
    isLabel: true,
    register: { ...register("zipCode", { ...zipCodeValidator(true) }) },
  },
  {
    name: "city",
    type: "text",
    text: "Miejscowość",
    isLabel: true,
    register: { ...register("city", { required: true }) },
  },
];
